<template>
    <v-form v-model="newOrderItemFormValid" ref="newOrderItemForm">
        <v-layout row wrap>
            <v-flex xs12>
            	<PrintableOrderSheet
                    :products="productsWithCategories"
                    :orderID="order.ID"
                    :showCommeneField="true"
                    :showStockEntry="showStockEntry"
                    :isPrintPage=false
                    :editable="true"
                    ref="printableOrderSheet">
            	</PrintableOrderSheet>
            </v-flex>
            <v-flex xs12>
            	<v-btn color="error" block @click="showConfirmDialog = true">Clear</v-btn>
            </v-flex>
        </v-layout>
        
    
        <v-dialog v-model="showConfirmDialog">
            <v-card>
                    <v-card-title class="headline">Clear current order?</v-card-title>
                <v-card-text>
                    <v-layout wrap>
                        Are you sure you want to clear all Quantity {{ showStockEntry ? 'and Stock ' : '' }} fields in the current order?
                    </v-layout>
                </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red"
                        class="white--text"
                        @click="showConfirmDialog = false">
                        No
                    </v-btn>
                    <v-btn
                        color="green"  
                        class="white--text"
                        @click="clear()">
                        Yes
                    </v-btn>
                    </v-card-actions>
            </v-card>
        </v-dialog>
    </v-form>
</template>

<script>
import validationRules from "../../helpers/validationrules";
import PrintableOrderSheet from './PrintableOrderSheet';
import util from '@/services/util';

export default {
	components: {
		PrintableOrderSheet
	},
	props: [
        'showStockEntry'
	],
	data(){
		return {
			newOrderItem: {},
			newOrderItemFormValid: false,
			rules: validationRules.rules,
            showConfirmDialog: false
		}
	},
	computed: {
        order(){
            return this.$store.state.placeOrderStore.order;
        },
        orderProducts(){
            return this.$store.state.placeOrderStore.orderProducts;
        },
		productsWithSuppliers(){
            return this.$store.state.placeOrderStore.orderSuppliers.productsWithSuppliers;
		},
		categoriesWithProducts(){
            return this.$store.state.placeOrderStore.orderSuppliers.categoriesWithProducts;
		},
        categories() {
            return this.$store.state.categoryStore.categories.filter(c => c.Active);
        },
        productsWithCategories(){
            return this.productsWithSuppliers.map(p => {
                let product = Object.assign({}, p);

                let categoryID = product.CategoryID;
                if(categoryID){
                    let category = this.categories.find(c => c.ID == categoryID);
                    product.Category = category;
                }

                return product;
            })
            .filter(p => p.Category)
            .sort(util.sortByName);
        }
	},
	methods: {
        resetValidation(){
            this.$refs.newOrderItemForm.resetValidation();
        },
        clear(){
            this.showConfirmDialog = false;
            this.$store.dispatch("placeOrderStore/clearOrderProducts");
            this.$refs.printableOrderSheet.clearInput();
        }
	},
}
</script>